import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class FixedTemplatesService {
  constructor(private http: HttpClient) {}

  public fetchFixedTemplates(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/fixedTemplates`
    return this.http.get(url, params)
  }

  public updateFixedTemplates(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/fixedTemplates`
    return this.http.put(url, params)
  }
}
